import { render, staticRenderFns } from "./MapAdmin.vue?vue&type=template&id=548b8504&"
import script from "./MapAdmin.vue?vue&type=script&lang=js&"
export * from "./MapAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports